import React, {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import FormatTimeStr from "../../helpers/FormatTimeStr";
import InterfaceBooking from "../../interface/InterfaceBooking";
import {useApptekster} from "../../apptekst-context";
import {SVVDefinitionList, SVVDefinitionListItem} from "@komponentkassen/svv-definition-list";
import {SVVBodyText, SVVHeading} from "@komponentkassen/svv-text";
import {SVVButton, SVVButtonCancel, SVVButtonRow} from "@komponentkassen/svv-button";

const RebookPreview = (props: {
  booking: InterfaceBooking;
  setNavState: (arg0: number) => void;
  abort: any;
  nesteUrl: string
}) => {
  const t = useApptekster();
  const navigate = useNavigate();
  const headingRef = useRef<HTMLHeadingElement | null>(null)

  useEffect(() => {
    if (headingRef?.current) {
      headingRef.current.focus()
    }
  }, [headingRef])

  const submit = (event: any) => {
    event.preventDefault();
    props.setNavState(0);
    navigate(props.nesteUrl)
  };

  const {
    booking
  } = props

  return (
    <>
      <SVVHeading
        level="h2"
        ref={headingRef}
        tabIndex={-1}
      >
        {t("timebestilling.endre")}
      </SVVHeading>
      {booking.bookedDateTime &&
        <SVVBodyText>
          {t("timebestilling.endre-timen")} {FormatTimeStr(booking.bookedDateTime)}
        </SVVBodyText>
      }
      <SVVDefinitionList>
        <SVVDefinitionListItem term={t("timebestilling.tjeneste")}>
          {booking.serviceName}
        </SVVDefinitionListItem>
        <SVVDefinitionListItem term={t("timebestilling.trafikkstasjon-og-tidspunkt")}>
          {booking.sectionName} - {booking?.bookedDateTime ? FormatTimeStr(booking.bookedDateTime) : t("timebestilling.klokkeslett-mangler")}
        </SVVDefinitionListItem>
        <SVVDefinitionListItem term={t("timebestilling.referansenummer")}>
          <span data-hj-suppresss>
            {props.booking?.bookingNumber || t("timebestilling.referansenummer-mangler")}
          </span>
        </SVVDefinitionListItem>
      </SVVDefinitionList>
      
      <div className="svv-padding-top--px32">
        <SVVButtonRow isFormRow>
          <SVVButton onClick={submit}>
            {t("timebestilling.endre")}
          </SVVButton>
          <SVVButtonCancel
            onClick={props.abort}
            color="secondary"
          >
            {t("timebestilling.avbryt")}
          </SVVButtonCancel>
        </SVVButtonRow>
      </div>
    </>
  );
};

export default RebookPreview;
